import { pxToRem } from "../inc/helpers";

export default class Navigation {
    constructor({ btn, nav, onBtnClick = null }) {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;

        this._open = false;
    }

    init() {
        this._btn?.addEventListener("click", this.toggleNav.bind(this));
        this._initProdNav();
    }

    _initProdNav() {
        const voice = this._nav.querySelector(".js-products-voice");
        const link = voice?.querySelector("a")?.href;
        const menu = document.querySelector(".js-nav-products");
        const menuClose = menu?.querySelector(".js-btn-menu-products-close");
        const menuInner = menu?.querySelector(".js-menu-products");
        const show = () => {
            menu?.removeAttribute("inert");
            if (!menu?.classList.contains("is-visible"))
                menu?.classList.add("is-visible");

            if (!document.body.classList.contains("overflow-hidden"))
                document.body.classList.add("overflow-hidden");
        };
        const hide = (e) => {
            menu?.classList.remove("is-visible");
            menu?.setAttribute("inert", "");
            document.body.classList.remove("overflow-hidden");
        };
        const onVoiceClick = (e) => {
            e.preventDefault();
            try {
                document.createEvent("TouchEvent");
                show();
            } catch (e) {
                window.location = link;
            }
        };
        voice?.addEventListener("click", onVoiceClick);
        voice?.addEventListener("mouseover", show);
        menu?.addEventListener("click", hide);
        menu?.addEventListener("mouseover", hide);
        menuClose?.addEventListener("click", hide);
        menuInner?.addEventListener("click", (e) => e.stopPropagation());
        menuInner?.addEventListener("mouseover", (e) => e.stopPropagation());
    }

    toggleNav(e) {
        e.preventDefault();
        this._open = !this._open;

        this._open ? this.openNav() : this.closeNav();
        this._onBtnClick?.(this._open);

        if (!this._open) {
            const productsMenu = document.querySelector(".js-nav-products");
            productsMenu?.classList.remove("is-visible");
            productsMenu?.setAttribute("inert", "");
            document.body.classList.remove("overflow-hidden");
        }
    }

    openNav() {
        this._btn.setAttribute("aria-expanded", true);
        this._nav.removeAttribute("inert");
    }

    closeNav() {
        this._btn.setAttribute("aria-expanded", false);
        this._nav.setAttribute("inert", "");
    }

    get open() {
        return this._open;
    }

    set open(bool) {
        this._open = bool;
        this._open ? this.openNav() : this.closeNav();
    }

    get nav() {
        return this._nav;
    }

    set nav(nav) {
        this._nav = nav;
    }

    get btn() {
        return this._btn;
    }

    set btn(btn) {
        this._btn = btn;
        this.init();
    }
}
